module.exports = __webpack_public_path__ + "img/92145.eb2c41e5.svg";